export function loadAnimation(containerId) {
    const container = document.getElementById(containerId);
    if (!container) {
        console.error(`Element with id '${containerId}' not found.`);
        return;
    }

    // Define commonly used values and functions
    const { random, cos, sin } = Math;
    const PI = Math.PI;
    const PI2 = PI * 2;
    const spread = 20;
    const sizeMin = 8;
    const sizeMax = 20;
    const eccentricity = 10;
    const deviation = 100;
    const dxThetaMin = -0.1;
    const dxThetaMax = -2 * dxThetaMin;
    const dyMin = 0.13;
    const dyMax = 0.18;
    const dThetaMin = 0.4;
    const dThetaMax = 0.3;
    let timer, frame, confetti = [];

    const colorThemes = [
        () => color(200 * random() | 0, 200 * random() | 0, 200 * random() | 0),
        () => color(200, 200 * random() | 0, 200 * random() | 0),
        () => color(200 * random() | 0, 200, 200 * random() | 0),
        () => color(200 * random() | 0, 200, 200),
        () => color(200, 100, 200 * random() | 0)
    ];

    function color(r, g, b) {
        return `rgb(${r},${g},${b})`;
    }

    function interpolation(a, b, t) {
        return (1 - cos(PI * t)) / 2 * (b - a) + a;
    }

    function createPoisson() {
        const radius = 1 / eccentricity;
        const radius2 = radius * 2;
        let domain = [radius, 1 - radius];
        let measure = 1 - radius2;
        let spline = [0, 1];

        while (measure > 0) {
            const dart = measure * random();
            let a, b, i, interval;
            for (i = 0; i < domain.length; i += 2) {
                [a, b] = [domain[i], domain[i + 1]];
                interval = b - a;
                if (dart < interval) {
                    spline.push(dart + a);
                    break;
                }
            }
            let c = dart - radius;
            let d = dart + radius;

            domain = domain.filter((_, i) => !(i % 2 ? _ >= c && _ <= d : _ >= c && _ <= d));
            measure = domain.reduce((sum, _, i) => (i % 2 ? sum + domain[i] - domain[i - 1] : sum), 0);
        }

        return spline.sort();
    }

    function Confetto(theme) {
        this.frame = 0;
        this.outer = document.createElement('div');
        this.inner = document.createElement('div');
        this.outer.appendChild(this.inner);

        const outerStyle = this.outer.style;
        const innerStyle = this.inner.style;
        const width = sizeMin + sizeMax * random();
        const height = sizeMin + sizeMax * random();

        Object.assign(outerStyle, {
            position: 'absolute',
            width: `${width}px`,
            height: `${height}px`,
            perspective: '50px',
            transform: `rotate(${360 * random()}deg)`,
            left: `${this.x}px`,
            top: `${this.y}px`
        });

        Object.assign(innerStyle, {
            width: '100%',
            height: '100%',
            backgroundColor: theme(),
            transform: `rotate3D(${cos(360 * random())},${cos(360 * random())},0,${this.theta}deg)`
        });

        this.axis = `rotate3D(${cos(360 * random())},${cos(360 * random())},0,`;
        this.theta = 360 * random();
        this.dTheta = dThetaMin + dThetaMax * random();
        this.x = window.innerWidth * random();
        this.y = -deviation;
        this.dx = sin(dxThetaMin + dxThetaMax * random());
        this.dy = dyMin + dyMax * random();
        this.splineX = createPoisson();
        this.splineY = this.splineX.map(() => deviation * random());
    }

    Confetto.prototype.update = function(height, delta) {
        this.frame += delta;
        this.x += this.dx * delta;
        this.y += this.dy * delta;
        this.theta += this.dTheta * delta;

        const phi = (this.frame % 7777) / 7777;
        const i = this.splineX.findIndex(s => s > phi) - 1;
        const rho = interpolation(this.splineY[i], this.splineY[i + 1], (phi - this.splineX[i]) / (this.splineX[i + 1] - this.splineX[i]));

        this.outer.style.left = `${this.x + rho * cos(phi * PI2)}px`;
        this.outer.style.top = `${this.y + rho * sin(phi * PI2)}px`;
        this.inner.style.transform = `${this.axis}${this.theta}deg)`;
        return this.y > height + deviation;
    };

    function poof() {
        if (!frame) {
            if (!(container instanceof HTMLElement)) {
                console.error('Container is not a valid HTMLElement');
                return;
            }
            document.body.appendChild(container);

            const theme = colorThemes[0];

            (function addConfetto() {
                confetti.push(new Confetto(theme));
                container.appendChild(confetti[confetti.length - 1].outer);
                timer = setTimeout(addConfetto, spread * random());
            })();

            let prev;
            requestAnimationFrame(function loop(timestamp) {
                const delta = prev ? timestamp - prev : 0;
                prev = timestamp;
                const height = window.innerHeight;

                confetti = confetti.filter(conf => !conf.update(height, delta));

                if (timer || confetti.length) {
                    frame = requestAnimationFrame(loop);
                } else {
                    document.body.removeChild(container);
                    frame = undefined;
                }
            });
        }
    }

    function stop() {
        if (frame) {
            cancelAnimationFrame(frame);
            frame = undefined;
        }

        if (timer) {
            clearTimeout(timer);
            timer = undefined;
        }

        confetti = [];
        container.innerHTML = '';
    }

    poof();

    return {
        stop: stop
    };
}
